module.exports = __webpack_public_path__ + "d4ff6592.png";